import React, { useCallback, useState, useEffect } from "react";
import { List, TextField } from "@mui/material";
import DisabledTextField from "../../DisabledTextField";
import ColumnHeader from "../../ColHeader";
import { RENTAL_TEXTILE_LAUNDRY } from "../../../constants";
import CustomAutocomplete from "../../CustomAutocomplete";
import FormTable from "../../FormTable1/FormTable";
import CustomAccordion from "../../CustomAccordion";
import DynamicOutputTable from "../../DynamicOutputTable";
import getEnergyCostByCountry from "../../../apis/getEnergy_cost_by_country";
import ApiClient from "../../../apisClient";
import CustomAlert from "../../Alert";

const api = new ApiClient();

const PotentialAccordian2 = () => {
  const [submittedData, setSubmittedData] = useState(null);
  const [visibleColumns, setVisibleColumns] = useState({
    input: true,
    input_1: true,
    input_2: false,
    input_3: false,
    input_4: false,
  });
  const [hiddenColumnsOrder, setHiddenColumnsOrder] = useState([]);
  const [recommendedWashTemps, setRecommendedWashTemps] = useState(["60","","","",""]);
  const [recommendedDryTemps, setRecommendedDryTemps] = useState(["60","","","",""]);
  const [cycleDuration, setCycleDuration] = useState(["","","","","" ]);
  const [country, setCountry] = useState("United States of America");
  const [costEnergy, setCostEnergy] = useState("");
  const [currency, setCurrency] = useState("usd");
  const [over100CleaningCycles, setOver100CleaningCycles] = useState(Array(5).fill("X100"));
  const [savedEnergyCost, setSavedEnergyCost] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(false);
  const [isReset, setIsReset] = useState(false);

  const handleWashTempChange = (event, index) => {
    const value = event.target.value;
    const updatedTemps = [...recommendedWashTemps];
    updatedTemps[index] = value;
    setRecommendedWashTemps(updatedTemps);
  };

  const handleDryTempChange = (event, index) => {
    const value = event.target.value;
    const updatedTemps = [...recommendedDryTemps];
    updatedTemps[index] = value;
    setRecommendedDryTemps(updatedTemps);
  };

  const handleCycleDurationChange = (event, index) => {
    const value = event.target.value;
    const updatedDuration = [...cycleDuration];
    updatedDuration[index] = value;
    setCycleDuration(updatedDuration);
  };

  const handleCountryChange = (event, newCountry) => {
    setCountry(newCountry);
  };

  const fetchEnergyCost = useCallback(
    async (selectedCountry) => {
      try {
        const energyCost = await getEnergyCostByCountry(selectedCountry, currency);
        setCostEnergy(energyCost);
      } catch (error) {
        console.error(`Error fetching energy cost for ${country}:`, error);
      }
    },
    [country, currency]
  );

  useEffect(() => {
  
    if (isAccordionExpanded ) {
      fetchEnergyCost(country);
    }
  }, [isAccordionExpanded]);

  const handleCountrySelect = (event, selectedCountry) => {
    if (selectedCountry) {
      setCountry(selectedCountry);
      fetchEnergyCost(selectedCountry);
    }
  };

  const handleHideColumn = (column) => {
    setVisibleColumns((prevState) => ({
      ...prevState,
      [column]: false,
    }));
    setHiddenColumnsOrder((prevState) => [...prevState, column]);
  };

  const handleShowColumn = (column) => {
    setVisibleColumns((prevState) => ({
      ...prevState,
      [column]: true,
    }));
    setHiddenColumnsOrder((prevState) =>
      prevState.filter((col) => col !== column)
    );
  };

  function getLastHiddenColumnName() {
    if (hiddenColumnsOrder.length === 0) {
      return null;
    }
    return hiddenColumnsOrder[hiddenColumnsOrder.length - 1];
  }

  const col = ["input", "input_1", "input_2", "input_3", "input_4"];
  const visibleColumnIds = col.filter((col) => visibleColumns[col]);
  const lastVisibleColumn = visibleColumnIds[visibleColumnIds.length - 1];
  const visibleColumnCount = visibleColumnIds.length;

  const [outputVisibleColumns, setOutputVisibleColumns] = useState(visibleColumns);

 
  const handleReset = () => {
    setIsReset(true);
    setRecommendedWashTemps(["60","","","",""]);
    setRecommendedDryTemps(["60","","","",""]);
    setCountry("United States of America");
    setCycleDuration(["","","","",""]);
    setAlertMessage("");
  };

  const isFormValid = () => {
    //check fields of visible columns are empty or not
   for (let i = 0; i < visibleColumnCount; i++) {
      if (
        recommendedWashTemps[i] === "" ||
        recommendedDryTemps[i] === "" ||
        cycleDuration[i] ===  ""
      ) {
        setAlertMessage("Please fill in all fields.");
        return false;
      }else if (
        recommendedWashTemps[i] < 0 ||
        recommendedDryTemps[i] < 0 ||
        cycleDuration[i] < 0
      ) {
        setAlertMessage("Values must be greater than zero.");
        return false;
      }else if (
        //check if the value is a number
        isNaN(recommendedWashTemps[i]) ||
        isNaN(recommendedDryTemps[i]) ||
        isNaN(cycleDuration[i])
      ) {
        setAlertMessage("Values must be numbers.");
        return false;
      }      
      else{
          setAlertMessage("");
      }
    }
    return true;

    
  };

  const handleSubmit_2 = async () => {
    if (!isFormValid()) {
      return;
    }
    setIsReset(false);
    const apiUrl = "/api/v1/potential-savings";
    const payload = {
      // Filter out empty strings and convert the list values to float
      washing_temps: recommendedWashTemps.filter(val => val !== "").map(parseFloat),
      drying_temps: recommendedDryTemps.filter(val => val !== "").map(parseFloat),
      energy_costs: parseFloat(costEnergy),
      duration_hours: cycleDuration.filter(val => val !== "").map(parseFloat),
    };
  

    try {
      const response = await api.post(apiUrl, payload);
      const data = response;

      console.log("Potential savings data:", data);
      setSubmittedData(payload);
      setSavedEnergyCost(data);
      setOutputVisibleColumns(visibleColumns);
    } catch (error) {
      console.error("Error fetching potential savings:", error);
    }
  };

  const PotentialRows = [
    {
      label: "Select Country",
      input: (
        <CustomAutocomplete
          inputValue={country}
          handleChange={handleCountryChange}
          handleSelect={handleCountrySelect}
        />
      ),
    },
    {
      label: "",
      input: (
        <ColumnHeader
          headerText={RENTAL_TEXTILE_LAUNDRY.POTENTIAL_SAVINGS_HEADERS[0]}
          onRemove={() => handleHideColumn("input")}
          onShow={handleShowColumn}
          isLastVisible={lastVisibleColumn === "input"}
          nextColumnId="input_1"
          visibleColumnCount={visibleColumnCount}
        />
      ),
      input_1: (
        <ColumnHeader
          headerText={RENTAL_TEXTILE_LAUNDRY.POTENTIAL_SAVINGS_HEADERS[1]}
          onRemove={() => handleHideColumn("input_1")}
          onShow={handleShowColumn}
          isLastVisible={lastVisibleColumn === "input_1"}
          nextColumnId="input_2"
          visibleColumnCount={visibleColumnCount}
        />
      ),
      input_2: (
        <ColumnHeader
          headerText={RENTAL_TEXTILE_LAUNDRY.POTENTIAL_SAVINGS_HEADERS[2]}
          onRemove={() => handleHideColumn("input_2")}
          onShow={handleShowColumn}
          isLastVisible={lastVisibleColumn === "input_2"}
          nextColumnId="input_3"
          visibleColumnCount={visibleColumnCount}
        />
      ),
      input_3: (
        <ColumnHeader
          headerText={RENTAL_TEXTILE_LAUNDRY.POTENTIAL_SAVINGS_HEADERS[3]}
          onRemove={() => handleHideColumn("input_3")}
          onShow={handleShowColumn}
          isLastVisible={lastVisibleColumn === "input_3"}
          nextColumnId="input_4"
          visibleColumnCount={visibleColumnCount}
        />
      ),
      input_4: (
        <ColumnHeader
          headerText={RENTAL_TEXTILE_LAUNDRY.POTENTIAL_SAVINGS_HEADERS[4]}
          onRemove={() => handleHideColumn("input_4")}
          onShow={handleShowColumn}
          isLastVisible={lastVisibleColumn === "input_4"}
          nextColumnId={getLastHiddenColumnName()}
          visibleColumnCount={visibleColumnCount}
        />
      ),
    },
    {
      label: RENTAL_TEXTILE_LAUNDRY.RECOMMENDED_WASH_TEMP,
      input: (
        <DisabledTextField width={"140px"} variant="filled" value={"60"} />
      ),
      input_1: (
        <TextField
          size="small"
          className="input-tf"
          type="number"
          placeholder="Standard Washing Temp"
          value={recommendedWashTemps[1]}
          required  
          onChange={(e) => handleWashTempChange(e, 1)}
        />
      ),
      input_2: (
        <TextField
          size="small"
          className="input-tf"
          type="number"
          placeholder="Standard Washing Temp"
          value={recommendedWashTemps[2]}
          required
          onChange={(e) => handleWashTempChange(e, 2)}
        />
      ),
      input_3: (
        <TextField
          size="small"
          type="number"
          className="input-tf"
          placeholder="Standard Washing Temp"
          value={recommendedWashTemps[3]}
          onChange={(e) => handleWashTempChange(e, 3)}
        />
      ),
      input_4: (
        <TextField
          size="small"
          className="input-tf"
          type="number"
          placeholder="Standard Washing Temp"
          value={recommendedWashTemps[4]}
          onChange={(e) => handleWashTempChange(e, 4)}
        />
      ),
    },
    {
      label: RENTAL_TEXTILE_LAUNDRY.RECOMMENDED_WASH_TEMP,
      input: (
        <DisabledTextField width={"140px"} variant={"filled"} value={60} />
      ),
      input_1: (
        <TextField
          size="small"
          className="input-tf"
          placeholder="Standard Drying Temp"
          type="number"
          value={recommendedDryTemps[1]}
          onChange={(e) => handleDryTempChange(e, 1)}
        />
      ),
      input_2: (
        <TextField
          size="small"
          className="input-tf"
          type="number"
          placeholder="Standard Drying Temp"
          value={recommendedDryTemps[2]}
          onChange={(e) => handleDryTempChange(e, 2)}
        />
      ),
      input_3: (
        <TextField
          size="small"
          className="input-tf"
          type="number"
          placeholder="Standard Drying Temp"
          value={recommendedDryTemps[3]}
          onChange={(e) => handleDryTempChange(e, 3)}
        />
      ),
      input_4: (
        <TextField
          size="small"
          className="input-tf"
          type="number"
          placeholder="Standard Drying Temp"
          value={recommendedDryTemps[4]}
          onChange={(e) => handleDryTempChange(e, 4)}
        />
      ),
    },
    {
      label: "Cost of energy per country ($/Kwh)",
      input: (
        <TextField
         
          size="small"
          className="textFieldCustomSmall"
          value={costEnergy}
          onChange={(e) => setCostEnergy(e.target.value)}
        />
      ),
      input_1: (
        <TextField
          size="small"
          className="textFieldCustomSmall"
          value={costEnergy}
          onChange={(e) => setCostEnergy(e.target.value)}
        />
      ),
      input_2: (
        <TextField

          size="small"
          className="textFieldCustomSmall"
          value={costEnergy}
          onChange={(e) => setCostEnergy(e.target.value)}
        />
      ),
      input_3: (
        <TextField
          size="small"
          className="textFieldCustomSmall"
          value={costEnergy}
          onChange={(e) => setCostEnergy(e.target.value)}
        />
      ),
      input_4: (
        <TextField
          size="small"
          className="textFieldCustomSmall"
          value={costEnergy}
          onChange={(e) => setCostEnergy(e.target.value)}
        />
      ),
    },
    {
      label: "Washing and drying cycle duration (hrs)",
      input: (
        <TextField
          size="small"
          type="number"
          className="input-tf"
          placeholder="Enter Duration"
          value={cycleDuration[0]}
          onChange={(e) => handleCycleDurationChange(e, 0)}
        />
      ),
      input_1: (
        <TextField
          size="small"
          type="number"
          className="input-tf"
          placeholder="Enter Duration"
          value={cycleDuration[1]}
          onChange={(e) => handleCycleDurationChange(e, 1)}
        />
      ),
      input_2: (
        <TextField
          size="small"
          className="input-tf"
          type="number"
          placeholder="Enter Duration"
          value={cycleDuration[2]}
          onChange={(e) => handleCycleDurationChange(e, 2)}
        />
      ),
      input_3: (
        <TextField
          size="small"
          type="number"
          className="input-tf"
          placeholder="Enter Duration"
          value={cycleDuration[3]}
          onChange={(e) => handleCycleDurationChange(e, 3)}
        />
      ),
      input_4: (
        <TextField
          size="small"
          type="number"
          className="input-tf"
          placeholder="Enter Duration"
          value={cycleDuration[4]}
          onChange={(e) => handleCycleDurationChange(e, 4)}
        />
      ),
    },
    {
      label: "Over 100 cleaning cycles",
      input: (
        <DisabledTextField
          width="140px"
          variant="filled"
          value={over100CleaningCycles[0]}
        />
      ),
      input_1: (
        <DisabledTextField
          width={"140px"}
          variant={"filled"}
          value={over100CleaningCycles[1]}
        />
      ),
      input_2: (
        <DisabledTextField
          width="140px"
          variant="filled"
          value={over100CleaningCycles[2]}
        />
      ),
      input_3: (
        <DisabledTextField
          width="140px"
          variant="filled"
          value={over100CleaningCycles[3]}
        />
      ),
      input_4: (
        <DisabledTextField
          width="140px"
          variant="filled"
          value={over100CleaningCycles[4]}
        />
      ),
    },
  ];

  const section_1 = [
    {
      title: RENTAL_TEXTILE_LAUNDRY.POTENTIAL_SAVINGS_TITLE,
      content: (
        <>
          <p className="accordian-text">
            {RENTAL_TEXTILE_LAUNDRY.POTENTIAL_SAVINGS_ACCORDIAN_TEXT}
            <br />
            <p className="accordian-text-bold">
              {RENTAL_TEXTILE_LAUNDRY.POTENTIAL_SAVINGS_ACCORDIAN_TEXT_BOLD}
            </p>
          </p>

          <FormTable
            rows={PotentialRows}
            onSubmit={handleSubmit_2}
            onReset={handleReset}
            visibleColumns={visibleColumns}
          />
          {alertMessage && <CustomAlert text={alertMessage} />}
          {submittedData && !alertMessage && !isReset && (
            <DynamicOutputTable
              visibleColumns={outputVisibleColumns}
              title="Estimated Energy Saved with NC with Ecoforce vs incumbent solutions"
              data={[
                {
                  label: "Recommended washing temp (C/F)",
                  value1: recommendedWashTemps[0],
                  value2: recommendedWashTemps[1],
                  value3: recommendedWashTemps[2],
                  value4: recommendedWashTemps[3],
                  value5: recommendedWashTemps[4],
                },
                {
                  label: "Recommended drying temp (C/F)",
                  value1: recommendedDryTemps[0],
                  value2: recommendedDryTemps[1],
                  value3: recommendedDryTemps[2],
                  value4: recommendedDryTemps[3],
                  value5: recommendedDryTemps[4],
                },
                {
                  label: "Cost of energy per country",
                  value1: costEnergy,
                  value2: costEnergy,
                  value3: costEnergy,
                  value4: costEnergy,
                  value5: costEnergy,
                },
                {
                  label: "Washing and drying cycle duration (hrs) ",
                  value1: cycleDuration[0],
                  value2: cycleDuration[1],
                  value3: cycleDuration[2],
                  value4: cycleDuration[3],
                  value5: cycleDuration[4],
                },
                {
                  label: "Over 100 cleaning cycles",
                  value1: over100CleaningCycles[0],
                  value2: over100CleaningCycles[1],
                  value3: over100CleaningCycles[2],
                  value4: over100CleaningCycles[3],
                  value5: over100CleaningCycles[4],
                },
                {
                  label: "Saved Energy Cost",
                  value1: savedEnergyCost[0],
                  value2: savedEnergyCost[1],
                  value3: savedEnergyCost[2],
                  value4: savedEnergyCost[3],
                  value5: savedEnergyCost[4],
                },
              ]}
            />
          )}
        </>
      ),
    },
  ];

  const handleAccordionExpand = (index) => {
    setIsAccordionExpanded(index !== null);
  };

  return (
    <CustomAccordion
      sections={section_1}
      isExpanded={false}
      onExpand={handleAccordionExpand}
    />
  );
};

export default PotentialAccordian2;